<template>
    <div :class="['content-editor', editActive ? 'active' : '']" :data-indicador="indicador">
        <button class="closeIcon" @click.prevent="inactiveEdit(); saveProductPrice();">
            <span></span>
        </button>
        <div class="row" >
            <div class="col-3">
                <label :for="'allow_quantity' + product.id">{{ lang.bsop_qty_selector }} </label>
                <div class="onoffswitch discount_active">
                    <input type="checkbox" class="onoffswitch-checkbox" :id="'allow_quantity' + product.id"
                        :checked="product.allow_quantity"
                        @change="onChangeAllowAuantity($event)"
                    />
                    <label class="onoffswitch-label" :for="'allow_quantity' + product.id">
                        <span class="onoffswitch-inner"></span>
                        <span class="onoffswitch-switch"></span>
                    </label>
                </div>
            </div>
            <div class="col-3">
                <div class="form-group">
                    <label >{{ lang.bsop_price_type }}</label>
                    <div class="input-group">
                        <select v-model="product.price_type" @change="saveProductPrice()">
                            <option value="fixed">{{ lang.bsop_fixed }}</option>
                            <option value="variable">{{ lang.bsop_variable }}</option>
                            <option value="contact">{{ lang.bsop_contact }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="form-group">
                    <label >{{ lang.bsop_sell_status }}</label>
                    <div class="input-group">
                        <select v-model="product.sell_status" @change="saveProductPrice()">
                            <option value="available">{{ lang.bsop_available }}</option>
                            <option value="showcase">{{ lang.bsop_showcase }}</option>
                            <option value="sold_out">{{ lang.bsop_sold_out }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="form-group">
                    <label >{{ lang.bsop_visibility }}</label>
                    <div class="input-group">
                        <select v-model="product.visibility_status" @change="saveProductPrice()">
                            <option value="published">{{ lang.bs_active }}</option>
                            <option value="hidden">{{ lang.bs_inactive }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <label for="inputAmount">{{ lang.bsop_amount }}</label>
                <div class="form-group">
                    <div class="input-group">
                        <AmountInput v-model="product.price"
                            :placeholder="lang.bsop_amount_ph"
                            :max="100000"
                            @save="saveProductPrice()"
                            @keydown.enter.prevent="noEnter($event)"
                            class_input="form-control price"
                        />
                    </div>
                </div>
            </div>
            <div class="col-4">
                <label >{{ lang.bs_discount }}</label>
                <div class="form-group">
                    <div class="input-group">
                        <span class="input-group-text" style="padding-left: 2px;padding-right: 2px;border: 0;background: transparent;border-bottom: 1px solid #e9eeef;">
                            <div class="onoffswitch discount_active">
                                <input type="checkbox" class="onoffswitch-checkbox" :id="'modeCacl' + product.id"
                                    :checked="product.discount_active"
                                    @change="onModeCalcChange" />
                                <label class="onoffswitch-label" :for="'modeCacl' + product.id">
                                    <span class="onoffswitch-inner"></span>
                                    <span class="onoffswitch-switch"></span>
                                </label>
                            </div>
                        </span>
                        <PercentInput v-model="product.discount_percent"
                            :placeholder="lang.bsop_discount_ph"
                            :max="99"
                            @save="saveProductPrice()"
                            @keydown.enter.prevent="noEnter($event)"
                            class_input="form-control discount_percent"
                            :modo_calc="product.discount_active ? 'percent' : 'none'"
                        />
                    </div>
                </div>
            </div>
            <div class="col-4 text-right">
                <label>{{ lang.bsop_final_price }}</label>
                <div class="form-group " style="display: flex; justify-content: end; align-items: center; height: 42px; font-size:16px; font-weight:bold;">
                    <span v-if="product.visibility_status=='hidden'" style="font-size:12px; font-weight:normal; opacity:0.5; margin-right:10px;">{{ lang.bsop_hidden_product }}</span>
                    <span v-else-if="product.price_type=='contact'" style="font-size:12px; font-weight:normal; opacity:0.5; margin-right:10px;">{{ lang.bsop_hidden_price }}</span>
                    <span v-else-if="product.sell_status=='showcase'" style="font-size:12px; font-weight:normal; opacity:0.5; margin-right:10px;">{{ lang.bsop_hidden_price }}</span>
                    <span v-else>
                        <span v-if="product.price_type=='variable'" >{{ lang.bsop_from }} </span>
                        {{currency}}
                        {{ precio_final | formatMoney}}
                    </span>
                </div>
            </div>
        </div>
        <span class="tooltip">{{ lang.bsop_wrong_format }}</span>
    </div>
</template>

<script>
import AmountInput from "@/apps/billing/components/calcManual/inputs/AmountInput.vue";
import PercentInput from "@/apps/billing/components/estpro/secForm/PercentInputInt.vue";
import { mapGetters } from "vuex";
export default {
    components: {
        AmountInput,
        PercentInput,
    },
    props: ['indicador', 'product', 'editPriceActive'],
    data(){
        return {
            lang: {
                bsop_qty_selector: '',
                bsop_price_type: '',
                bsop_fixed: '',
                bsop_variable: '',
                bsop_contact: '',
                bsop_sell_status: '',
                bsop_available: '',
                bsop_showcase: '',
                bsop_sold_out: '',
                bsop_visibility: '',
                bs_active: '',
                bs_inactive: '',
                bsop_amount: '',
                bsop_amount_ph: '',
                bs_discount: '',
                bsop_discount_ph: '',
                bsop_final_price: '',
                bsop_hidden_product: '',
                bsop_hidden_price: '',
                bsop_from: '',
                bsop_wrong_format: '',
                bsop_incorrect_amount: '',
                bs_error: '',
                bs_could_not_save: '',
            },
            loadSave: false,
            editActive: this.editPriceActive || false,
            apis: null,
            currency: null,
            price_old: null,
            qty: 1,
            contact_btn_text: 'Contact',
            show_btn_ws: false,
        };
    },
    computed: {
        ...mapGetters("ModApps/Marketea/", {
            get_currency: "get_bStore_currency",
            langGetter: "lang",
        }),
        precio_final: function() {
            if(this.product.discount_active && this.product.discount_percent > 0){
                return (this.product.price - ((this.product.discount_percent * this.product.price) / 100));
            }
            return this.product.price;
        }
    },
    watch: {
        langGetter() { this.lang = this.$store.getters['ModApps/Marketea/lang']; },
        get_currency(){
            this.currency = this.get_currency;
            // console.log('watch currency', this.currency)
        },
        editPriceActive(newVal){
            console.log('watch editActive', newVal)
            this.editActive = newVal;
            if(newVal){
                this.activeEdit()
            }
        },
    },
    created(){
        let t = this;
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.bStore;
        this.currency = this.$store.getters['ModApps/Marketea/get_bStore_currency'];
        this.price_old = this.product.price
        // console.log('created editActive', this.editActive)
    },
    methods: {
        activeEdit(){
            let t = this;
            setTimeout(() => {
                if(t.$refs.editPrice_product){
                    t.$refs.editPrice_product.focus();
                }
            }, 200);
        },
        inactiveEdit(){
            // console.log('inactiveEdit');
            this.editActive = false;
            this.$emit('closeEditPrice', false); // Emitir evento para cerrar el editor de precio
        },
        noEnter(e){
            let t = this;
            var code = (e.which) ? e.which : e.keyCode;
            if(code == 13){
                e.preventDefault();
                t.inactiveEdit();
                t.saveProductPrice()
            }
        },
        saveProductPrice(){
            let t= this;
            let urlService = t.apis.set(3)// setProduct
            if(t.isEmptyNaN(t.product.price)){
                t.$notify({
                    group: "noti",
                    type: "error",
                    title: t.lang.bs_error,
                    text: t.lang.bsop_incorrect_amount,
                });
                t.product.price = t.price_old;
            }else{
                if(!t.loadSave){
                    t.loadSave = true;
                    // @ts-ignore
                    window.master.post(urlService, t.product)
                    .then((response) => {
                        console.log(urlService, t.product, response.data);
                        t.loadSave = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        t.loadSave = false;
                        t.$notify({
                            group: "noti",
                            type: "error",
                            title: t.lang.bs_error,
                            text: t.lang.bs_could_not_save,
                        });
                    });
                }
            }
        },
        onModeCalcChange(e){
            this.product.discount_active = Number(e.target.checked); // convert boolean to 0 or 1
            this.saveProductPrice();
        },
        onChangeAllowAuantity(e){
            this.product.allow_quantity = Number(e.target.checked); // convert boolean to 0 or 1
            this.saveProductPrice();
        },
        convertToNumeric(val){
            let num;
            if (typeof val === "boolean") {
            // Caso: ya es boolean
            num = Number(val);
            } else if (typeof val === "string") {
            // Caso: es string, validamos contenido
            num = (val.toLowerCase() === "true") ? 1 : 0;
            } else {
            // Otro tipo, opcional
            num = 0;
            }
            return num;
        },
        isEmptyNaN(val){
            if (isNaN(val)){ return true;}
            else if (val==null){ return true;}
            else if (val==''){ return true;}
            else{ return false;}
        },
    }
}
</script>
<style lang="scss" scoped>
.content-editor {
    display: none;
    position: relative;
    width: 100%;
    background: #f7f7f7;
    margin-top: 10px;
    margin-bottom: 50px;
    padding: 10px;
    border-radius: 4px;
    &.active {
        display: block;
        position: absolute;
        top: 100px;
        left: 40px;
        z-index: 10;
        height: 300px;
        width: 80%;
        button.closeIcon {
            right: 0px;
            top: -15px;
            width: 40px;
            background: #fff;
            span:before, span:after {
                content: "";
                width: 30px;
                height: 1.2px;
                background-color: #000;
            }
        }}
    .label_amount, .label_discount {
        display: flex;
        flex-direction: column;
    }
    label {
        font-size: 12px;
        margin-bottom: 5px;
        line-height: 1;
    }
    .onoffswitch.discount_active {
        margin: 0;
        .onoffswitch-inner:before {
            padding-left: 10px;
        }
    }
    input, select {
        width: 100px;
        -moz-appearance: textfield;
        border: 0px;
        border-bottom: 1px solid #ddd;
        line-height: 1.1;
        min-height: 42px;
        text-transform: capitalize;
        &:focus {
            outline: none;
        }
        &[readonly="readonly"] {
            border-bottom: 1px dashed #ddd;
            cursor: not-allowed;
            opacity: 0.2;
        }
        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
    }
    input.price {text-align: right;}
    input.discount_percent {text-align: right; width: 70px; flex: auto;}
}
</style>
